//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "question",
    data() {
        return {
            lang: '',
        }
    },
    methods: {},
    mounted() {
    },
    created() {
        this.lang = window.localStorage.lang
    }
}



// WEBPACK FOOTER //
// ./src/page/activity5G/question.vue